module.exports = __webpack_public_path__ + "img/reverse-triangle.dd856af0.svg";